export default __webpack_public_path__ + "2f32cbc074f648021199f4a4aa21dca5.png";